import React, {useState} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from "@material-ui/core";

interface ConfiguationConfigurationCreateDialogProps {
  open: boolean;
  onClose: () => void;
  onCreate: (name: string) => void;
}

const ConfigurationCreateDialog: React.FC<ConfiguationConfigurationCreateDialogProps> = ({
  open,
  onClose,
  onCreate,
}) => {
  const [name, setName] = useState<string>("");
  return (
    <Dialog fullWidth maxWidth={"sm"} open={open} onClose={onClose}>
      <DialogTitle>Create new Configuration</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will create a new configuration.
        </DialogContentText>
        <TextField
          style={{width: "100%"}}
          label="name"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={name.length === 0}
          onClick={() => {
            onCreate(name);
            onClose();
          }}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigurationCreateDialog;
